import { Route, Switch } from 'react-router-dom'
import { withRouter } from "react-router";
import LoaderTerpel from 'components/LoaderTerpel/LoaderTerpel'
import React, { lazy, Suspense } from 'react'


const Bitacora = lazy(async () => import('./Bitacora/Bitacora'))

const Bitacoras = ({ match }) => {

    return (
        <div className="app-wrapper">
            <Switch>
                <Suspense fallback={<LoaderTerpel />}>
                    <Route path={`${match.url}/eventos`} component={Bitacora} />
                </Suspense>
            </Switch>
        </div>
    )
}

export default withRouter(Bitacoras);
